import React from "react";
import { Zap, Eye } from "lucide-react";

export default function MissionVision() {
  return (
    <div className="medium-screen bg-gray-50 py-16 px-4 sm:px-6 lg:px-8 pb-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-blue-100 text-blue-600 px-6 py-2 rounded-full text-sm font-medium mb-6">
            OUR PURPOSE
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900">
            Mission & Vision
          </h1>
        </div>

        {/* Cards Container - Scrollable on mobile */}
        <div className="overflow-x-auto pb-4 -mx-4 px-4 sm:overflow-visible">
          <div className="flex gap-6 min-w-max sm:min-w-0 sm:grid sm:grid-cols-2 lg:gap-8">
            {/* Mission Card */}
            <div className="bg-white rounded-2xl shadow-sm p-8 flex-shrink-0 w-80 sm:w-auto">
              <div className="bg-blue-500 text-white w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                <Zap size={28} />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Our Mission
              </h2>
              <p className="text-gray-600 leading-relaxed">
                To empower businesses with innovative technology solutions that
                drive growth, enhance efficiency, and create meaningful digital
                experiences. We are committed to delivering excellence through
                creativity, expertise, and unwavering dedication to our clients'
                success.
              </p>
            </div>

            {/* Vision Card */}
            <div className="bg-white rounded-2xl shadow-sm p-8 flex-shrink-0 w-80 sm:w-auto">
              <div className="bg-blue-500 text-white w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                <Eye size={28} />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Our Vision
              </h2>
              <p className="text-gray-600 leading-relaxed">
                To be the leading catalyst for digital transformation,
                recognized globally for our innovative solutions, exceptional
                service, and positive impact on businesses and communities. We
                envision a future where technology seamlessly enhances human
                potential.
              </p>
            </div>
          </div>
        </div>

        {/* Scroll indicator for mobile */}
        <div className="sm:hidden text-center mt-6">
          <p className="text-sm text-gray-500">← Swipe to see more →</p>
        </div>
      </div>
    </div>
  );
}
